var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          ref: "update-version-modal",
          attrs: {
            id: "update-version-modal",
            title: _vm.$t("message.versionupdate"),
            hideHeaderClose: "",
            hideFooter: "",
            noCloseOnBackdrop: ""
          }
        },
        [
          _c("div", [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("message.waitforamomentforupdate")))
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.treesoft.io/th/version?v=" +
                    _vm.$store.getters["getAppLatestVersion"],
                  target: "_blank"
                }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("message.version", {
                        string: _vm.$store.getters["getAppLatestVersion"]
                      })
                    ) +
                    "\n        "
                ),
                _c("i", { staticClass: "fas fa-external-link-alt" })
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "progress mt-3", staticStyle: { height: "3px" } },
            [
              _c("div", {
                staticClass: "progress-bar",
                style: "width: " + _vm.progress + "%;",
                attrs: {
                  "aria-valuenow": _vm.progress,
                  role: "progressbar",
                  "aria-valuemin": "0",
                  "aria-valuemax": "100"
                }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-331fd684", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-331fd684","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/version/DetectVersion.vue
// module id = null
// module chunks = 